import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { InboxComposeDialogComponent } from '../compose/compose.component';
import { GetAllRecepientsAction, GetInboxLabelsAction } from '../../store/actions/inbox.actions';
import { InboxState } from '../../store/reducers/inbox.reducers';
import { Subject } from 'rxjs';
import { getInboxLabels } from '../../store/selectors/inbox.selectors';
import { takeUntil } from 'rxjs/operators';



@Component({
    standalone: false,
    selector       : 'inbox-sidenav',
    templateUrl    : './inbox-sidenav.component.html',
    styleUrls      : ['./inbox-sidenav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InboxSidenavComponent implements OnInit,OnDestroy
{
    labels: any[];
    dialogRef: any;
    labels$: Observable<any>;
    unSubscribe$ = new Subject<void>();
    constructor(
      public dialog: MatDialog,
      private store: Store<InboxState>
    )
    {
    }
  ngOnInit() {
    this.store.dispatch(new GetInboxLabelsAction());
    this.store.dispatch(new GetAllRecepientsAction());
    this.labels$=this.store.select(getInboxLabels).pipe(takeUntil(this.unSubscribe$));
  }
    composeDialog()
    {
        this.dialogRef = this.dialog.open(InboxComposeDialogComponent, {
            panelClass: 'mail-compose-dialog'
        });
        this.dialogRef.afterClosed()
            .subscribe(response => {
                if ( !response )
                {
                    return;
                }
                const actionType: string = response[0];
                const formData: FormGroup = response[1];
                switch ( actionType )
                {
                    /**
                     * Send
                     */
                    case 'send':
                        console.log('new Mail', formData.getRawValue());
                        break;
                    /**
                     * Delete
                     */
                    case 'delete':
                        console.log('delete Mail');
                        break;
                }
            });
    }
  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
